module.exports = __webpack_public_path__ + "04_medium_gold.afe97d7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/04_medium_gold.png
// module id = wlLa
// module chunks = 0